var React = require('react');

function Street (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M137.62 794.05H0L201.36 0h137.62L538.9 794.05H407.07L369.4 664.08H244.82l33.32-156.45h55.05l-52.15-218.75h-21.73L137.62 794.05z","data-name":"Layer 2"}));
}

Street.defaultProps = {"viewBox":"0 0 538.9 794.05"};

module.exports = Street;

Street.default = Street;
